<template>
  <div>
    <div class="my-2">
      <ve-table
          v-if="employeeObjectives.length"
          :columns="columns"
          :table-data="employeeObjectives"
      />
    </div>
    <EditGoal
        :info="info"
        :showEditGoal="showEditGoal"
        :handleEditCallback="refreshObjectives"
        @close="close"
    ></EditGoal>
    <action-warning
        :message="message"
        :set-is-confirmed="setIsConfirmed"
        :show-warning="showWarning"
        @close="showWarning = false"
        :title="title"
    >

    </action-warning>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import moment from "moment";
import ActionWarning from "@/utils/actionWarning";

export default {
  name: 'ObjectivesGoals',
  props:["employeeObjectives", "refreshObjectives"],
  components: {
    ActionWarning,
    EditGoal: () =>
        import("@/components/PerformanceReview/objectives/editGoal.vue"),

  },
  data() {
    return {
      loading: false,
      message: null,
      showWarning: false,
      title: "",
      employeeData: [], // For grouped data (employees and their objectives)
      viewDialog: false,
      selectedObjective: {}, // Stores the selected objective for the modal
      reviewPeriods: [],
      currentPeriod: null,
      objectivesDrawer: false, // Controls the visibility of the objectives sidebar
      selectedEmployeeName: '',
      columns: [
        { field: "GoalName", key: "a", title: "Goal Name", align: "left" },
        {
          field: "GoalMeasure",
          key: "b",
          title: "Goal Measure",
          align: "left",
          renderBodyCell: ({ row }) => (
              <p class="capitalize">{row.GoalMeasure}</p>
          ),
        },
        {
          field: "Weight",
          key: "weight",
          title: "Weight",
          align: "center",
          renderBodyCell: ({ row }) => (row.Weight ? row.Weight : "...."),
        },
        {
          field: "StartDate",
          key: "c",
          title: "Start Date",
          align: "left",
          renderBodyCell: ({ row }) =>
              moment(row.StartDate).format("DD/MM/YYYY"),
        },
        {
          field: "EndDate",
          key: "x",
          title: "End Date",
          align: "left",
          renderBodyCell: ({ row }) => moment(row.EndDate).format("DD/MM/YYYY"),
        },
        {
          field: "Target",
          key: "d",
          title: "Target",
          align: "left",
        },

        {
          field: "Description",
          key: "f",
          title: "Description",
          align: "left",
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
              <ve-popper
                  trigger="clickToOpen"
                  options={{
                    placement: "top",
                    modifiers: { offset: { offset: "0,10px" } },
                  }}
              >
                <div class="bg-white p-2 shadow-md popper">
                  <button
                      class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                      style="boder-radius: 0 !important"
                      onClick={() => this.handleEditButtonClick(row)}
                  >
                    Edit
                  </button>
                  <button
                      class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                      style="boder-radius: 0 !important"
                      onClick={() => this.handleDeleteButtonClick(row)}
                  >
                    Delete
                  </button>
                </div>

                <button slot="reference">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                  >
                    <circle cx="12" cy="2" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="22" r="2" />
                  </svg>
                </button>
              </ve-popper>
          ),
        },
      ],
      editModalVisible: false,
      editForm: {
        StrategicGoal: '',
        GoalName: '',
        StartDate: '',
        EndDate: '',
        GoalMeasure: '',
        Target: '',
        Weight: '',
        Description: '',
      },
      showEditGoal:false,
      info: null,
      objectiveToDelete:"",
    };
  },

  created() {
    this.getPerformancePeriodSetups();
  },

  methods: {
    handleEditCallback() {
      this.getPerformancePeriodSetups()
    },
    handleDeleteButtonClick(Objective) {
      console.log(Objective)
      this.title = `Delete ${Objective.GoalName}`;
      this.message = `You are about to delete ${Objective.GoalName} from the goals list!`;
      this.objectiveToDelete = Objective.ObjectiveId;
      this.showWarning = true;
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.objectiveToDelete) {
        this.deleteGoal(this.objectiveToDelete);
        return;
      }
    },
    close() {
      this.showEditGoal = false;
    },
    handleEditButtonClick(row) {
      this.info = {
        ...row,
        ObjectiveId: row.ObjectiveId,
        GoalName: row.GoalName,
        StartDate: row.StartDate
            ? new Date(row.StartDate).toISOString().split("T")[0]
            : "",
        EndDate: row.EndDate
            ? new Date(row.EndDate).toISOString().split("T")[0]
            : "",
        GoalMeasure: row.GoalMeasure,
      };

      this.showEditGoal = true;
    },
    deleteGoal(ObjectiveId) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          ObjectiveId,
        },
      };
      const apiUrl = `${this.getOrganization}/performance/objective/v1/delete`;

      axios
          .delete(apiUrl, options)
          .then((response) => {
            if (response.data.StatusCode == 200) {
              this.$notify({
                title: "Success",
                message: response.data.StatusMessage,
                type: "success",
              });
              this.refreshObjectives()
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
    },
    setCurrentPeriod() {
      this.currentPeriod = this.reviewPeriods.find((period) => period.Active == true)
      },
    getPerformancePeriodSetups() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.reviewPeriods = response.data.Data;
            this.setCurrentPeriod();
          } else {
            this.$notify.error({
              title: 'Failure',
              message: response.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: 'Failure', message: error.message });
        }
      );
    },
        // Method to handle row expansion
    handleExpand(row, expandedRows) {
      expandedRows;
      // console.log('Row expanded:', row);
    },

    openViewModal(row) {
      // Check if objectives exist
      if (row && row.length > 0) {
        // Choose the first objective or modify this logic based on your needs
        this.selectedObjective = row;
        this.viewDialog = true;
      } else {
        this.$notify.warning('No objectives found for this employee.');
      }
    },

    hasWarnings(totalWeight) {
      return totalWeight < 100 || totalWeight > 100;
    },

    getWeightClass(totalWeight) {
      const tw = parseFloat(totalWeight);
      if (tw < 100) {
        return 'text-warning'; // Use a CSS class to apply warning styling
      } else if (tw > 100) {
        return 'text-danger'; // Use a CSS class to apply danger styling
      } else if (tw === 100) {
        return 'text-success'; // Use a CSS class to apply success styling
      }
      return '';
    },

    // Truncate the description text to a single line
    truncateText(text) {
      return text.length > 15 ? text.substring(0, 15) + '...' : text;
    },

    // Format ISO date into a readable format
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(); // Customize format as needed
    },

    handleAction(row, action) {
      if (action === 'edit') {
        this.openEditModal(row);
      } else if (action === 'delete') {
        this.deleteObjective(row);
      }
    },
    openEditModal(row) {
      // Populate the edit form with selected row data

      // Populate the edit form with the data from the selected objective
      this.editForm = {
        ...row,
        StartDate: row.StartDate, // Convert to Date object
        EndDate: row.EndDate, // Convert to Date object
      };

      this.editModalVisible = true;
    },
    submitEditForm() {
      // Handle form submission logic here
      // console.log('Submitting edited objective:', this.editForm);
      this.editModalVisible = false;

      this.loading = true;

      // Construct the URL with organization and API version
      const url = `${this.getOrganization}/performance/objective/${this.$ApiVersion}/edit`;

      // Prepare the payload for the PUT request
      const payload = {
        ObjectiveId: this.editForm.ObjectiveId,
        StrategicGoalId: this.editForm.StrategicGoalId, // If provided by your form
        GoalName: this.editForm.GoalName,
        StartDate: this.editForm.StartDate, // Convert to ISO string
        EndDate: this.editForm.EndDate, // Convert to ISO string
        GoalMeasure: this.editForm.GoalMeasure,
        Target: this.editForm.Target,
        Description: this.editForm.Description,
        Weight: this.editForm.Weight,
      };

      // Axios options including Authorization token
      const options = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.getToken}`, // Authorization token
        },
      };

      // Send the PUT request
      axios
        .put(url, payload, options)
        .then((response) => {
          this.loading = false; // Stop loading indicator
          // console.log(response);
          if (response.data.StatusCode === 200) {
            // Show success notification

            this.$notify({
              title: 'Success',
              message: 'Objective updated successfully!',
              type: 'success',
            });
            this.editModalVisible = false; // Close modal
            this.objectivesDrawer = false;
            this.fetchEmployeeObjectives(); // Refresh objectives if needed
          } else {
            this.$notify.error({
              title: 'Failure',
              message: response.data.StatusMessage,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error('Error updating objective:', error);
          this.$notify.error({
            title: 'Error',
            message:
              'There was an issue updating the objective. Please try again.',
          });
        });
    },
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),

    // Calculate total weight of all goals
    currentEmpTotalWeight() {
      return this.employeeObjectives.reduce((sum, obj) => sum + obj.Weight, 0);
    },
  },
};
</script>

<style scoped>
.el-icon-more {
  cursor: pointer;
}

/* Styling for different warning states */
.text-warning {
  color: #e6a23c; /* Warning color */
}

.text-danger {
  color: #f56c6c; /* Danger color */
}

.text-success {
  color: #67c23a; /* Success color */
}

.warning-message {
  margin-top: 10px; /* Space between messages */
}
</style>
